module.exports = __webpack_public_path__ + "img/third_de.f8ed374d.jpg";